$shm_hitalama_map_page_dragger $mol_button_minor
	Map_page $shm_hitalama_map_page
	sub /
		<= Icon_1 $mol_icon_dots_vertical
		<= Icon_2 $mol_icon_dots_vertical
	event *
		^
		pointerdown? <=> pointerdown? null
	plugins /
		^
		<= Hovered $shm_hitalama_hovered
			hovered? <=> hovered? false
		<= Keepsize $shm_hitalama_keepsize
			zoom <= zoom
			min_zoom 5
			anchor_hor <= anchor_hor
			anchor_vert <= anchor_vert
	x 0
	y 0
	anchor_hor \left
	anchor_vert \bottom
	zoom <= zoom_for_dragger 1
	widget? null
	widget_raw? null
	set_pos null
	style *
		^
		top <= top \100px
		left <= left \100px
